import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import eomMasterService from "../services/eom-master-service";
import eomCensusService from "../services/eom-census-service";

const CreateCensus = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [parentList, setParentList] = useState([]);
  const [parent, setParent] = useState("");
  const [groupList, setGroupList] = useState([]);
  const [group, setGroup] = useState("");
  const [chargeCodeList, setChargeCodeList] = useState([]);
  const [chargeCode, setChargeCode] = useState("");
  const { id } = useParams();

  useEffect(() => {
    getPayors();
  }, []);

  useEffect(() => {
    if (parent) {
      getGroups(parent);
      setChargeCode("");
    }
  }, [parent]);
  useEffect(() => {
    if (group) getChargeCodes(parent, group);
  }, [group]);
  const getPayors = async () => {
    try {
      let resp = await eomMasterService.getPayors();
      if (resp) {
        setParentList(resp);
      }
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting payors. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id) getData(id);
  }, [id]);

  const getGroups = async (parent) => {
    let totalGroupList = [];
    try {
      totalGroupList = await eomMasterService.getGroupCodes(parent);
      setGroupList(totalGroupList);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting groups. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const getChargeCodes = async (parent, group) => {
    try {
      var codes = await eomMasterService.getUniqueCodes(parent, group);
      setChargeCodeList(codes);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting charge codes. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const [census, setCensus] = useState("");
  const [error, setError] = useState(false);
  const [details, setdetails] = useState({});
  const getData = async () => {
    try {
      if (!id) return;
      setLoading(true);
      const resp = await eomCensusService.getData(id);
      setdetails(resp);
      setParent(resp?.payor);
      setGroup(resp?.group);
      setChargeCode(resp?.unique);
      setCensus(resp?.census);

      getPayors();
      getGroups([resp?.payor]);
      getChargeCodes([resp?.payor], [resp?.group]);

      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while getting  details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  const onSubmit = async () => {
    try {
      if (!parent.length || !group.length || !census) {
        setError(true);
        return;
      }
      var data = {
        payor: parent,
        group: group,
        unique: chargeCode,
        census: Number(census),
      };
      if (details?.id) {
        data["id"] = details?.id;
        await eomCensusService.updateData(data);
      } else {
        await eomCensusService.createData(data);
      }
      await history.push("/census");
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error submitting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <CipHeader />
      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3 w-full">
          <div className="w-full text-darkclr font-semibold leading-10 ">
            <span className="text-xl">{id ? "EDIT" : "CREATE"}</span>
          </div>
        </div>
        <div className="px-12 py-5">
          <ul className="text-left">
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Payor
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>

              <select
                name="payor"
                aria-label="Select Payor"
                onChange={(e) => setParent(e.target.value)}
                value={parent}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="0">Select Payor</option>
                {parentList
                  ? parentList.map((item, i) => {
                      return (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      );
                    })
                  : null}
              </select>
              {error && parent.length === 0 && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify payor
                </p>
              )}
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Group
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="group"
                aria-label="Select group"
                onChange={(e) => setGroup(e.target.value)}
                value={group}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="0">Select Group</option>
                {groupList
                  ? groupList.map((item, i) => {
                      return (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      );
                    })
                  : null}
              </select>
              {error && group.length === 0 && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify group
                </p>
              )}
            </li>

            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Charge Code
              </label>
              <select
                name="unique"
                aria-label="Select charge code"
                onChange={(e) => setChargeCode(e.target.value)}
                value={chargeCode}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="0">Select Charge Code</option>
                {chargeCodeList
                  ? chargeCodeList.map((item, i) => {
                      return (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      );
                    })
                  : null}
              </select>
              
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Census
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>

              <input
                id="census"
                name="census"
                type="number"
                placeholder="Census"
                value={census}
                onChange={(e) => setCensus(e.target.value)}
                className={` ${
                  error && census.length === 0 ? "border-red-400" : ""
                } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />

              {error && census.length === 0 && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify census
                </p>
              )}
            </li>

            <li className="text-center">
              <button
                disabled={loading}
                onClick={() => onSubmit()}
                className={
                  loading
                    ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    : "text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                }
              >
                SUBMIT
              </button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(CreateCensus)
);
